import http from 'plugins/axios';

export default {
  getRecords(data) {
    return http.get({
      url: '/la/admin/current/interest/list',
      data
    });
  },
  gitSwitch(data) {
    return http.get({
      url: '/la/admin/current/bigSwitch',
      data
    });
  },
  setSwitch(data) {
    return http.post({
      url: '/la/admin/current/bigSwitch',
      data,
      dataType: 'form'
    });
  },
  reSend(data) {
    return http.post({
      url: '/la/admin/current/Interest/issue',
      data,
      dataType: 'form'
    });
  }
};
